module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/loader.gif"),
      "alt": "loader"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d73ef48","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = 735
// module chunks = 1